// services/ads.js
import api from './api';

export const AdsAPI = {
  listAds: (params = {}) =>
    api.get('/ads', {
      params,
      // Ensure we hit the appeals backend
      system: 'appeals'
    }),
  createAd: (payload) =>
    api.post('/ads', payload, {
      // Ensure we hit the appeals backend
      system: 'appeals'
    })
};

